<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">Select Compartments</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>
                    {{productToAssign.product}} - {{productToAssign.quantity}}L Ordered
                </p>
                <p>
                    Total Amount of Product Assigned: {{totalAmountAssignedForProduct}}
                </p>
                <p>
                    Total Amount of Product Unassigned: {{totalAmountUnassignedForProduct}}
                </p>
                <p class="text-danger" v-if="vehicleId === null || vehicleId < 1">
                    Select Vehicle, before assigning compartments
                </p>
                <p class="text-danger">
                    {{entireQuantityNotAssignedMessage}}
                </p>
                
                <data-table :headings="vehicleCompartmentsHeadings"
                            :data="vehicleCompartments"
                            :hasActions="true"
                            :hasCustomActionComponent="true"
                            :pagingDetails="pagingDetails"
                            :hasNoFilter="true">
                    <template #actionComponent="{ compartmentProduct, selected, cannotSelect }">
                        <input type="checkbox" :checked="selected" @change="onCompartmentSelect(compartmentProduct)" :disabled="cannotSelect">
                    </template>
                </data-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="onSaveClick">Save</button>
                <button type="button" class="btn btn-secondary" @click="onModalCloseClick">Cancel</button>
            </div>
        </div>
    </div>
</div>